import { CountrySelect } from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";
import { useState } from 'react';
import { doc, setDoc } from "firebase/firestore"; 
import { database } from "../firebaseConfig2";



function Join() {
    const [country, setCountry] = useState(null);
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);


    //handle emails

    // const [error, setError] = useState(null)


    //set data
    const saveResponse = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target); 
        const date = new Date().toString();

         // Get individual values by input name attributes
        let name = formData.get('name');
        let email = formData.get('email');
        // let country = formData.get('country');
        // let passphrase = formData.get('passphrase');
        let website = formData.get('site');
        let showEmail = formData.get('show-email');
        let princess = formData.get('princess');

        setLoading(true);
        await setDoc(doc(database, "stp_fans_queue", date), {
            name: name,
            email: email,
            country: country.name,
            // passphrase: passphrase,
            website: website,
            showEmail: showEmail,
            isAdded: false,
            princess: princess
        });
         try {
            const response = await fetch('https://node.calicocafe.xyz/api/emails/stp', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    name: name,
                    email: email,
                    country: country.name,
                    // passphrase: passphrase,
                    website: website,
                    showEmail: showEmail,
                    isAdded: false,
                    princess: princess
                })
            })
            
            if (!response.ok) {
                throw new Error('Failed to send email');
            } 
            setLoading(false);
            // const user = await response.json()
            // console.log('Created:', user)
            // setFormData({ name: '', email: '' })
            } catch (error) {
            console.error(error.message)
            } finally {
            setLoading(false)
            setSubmitted(true)
            }
      

    }
    return (
    <div className="fans-list-container" id="join-container">
        {/* <div className="join-bg"></div> */}
        {/* <div> */}
            <div className="header-bar">Join</div>
            <div className="info">
                <p>Submit the below form to join the fanlisting! </p>
                <p>
                If you encounter any problems, or if you need to update your fanlisting information, feel free to <a href="mailto:marketchipping@proton.me">email me.</a>
                </p>
                <br/>
            </div>
            <div className="loading" style={{display: loading === true ? 'block' : 'none' }}>Loading...</div>
            <div className="submitted" style={{display: submitted === true ? 'block' : 'none' }}>
                <p>Submitted!</p>
                <p>You will recieve an email to the listed address when you've been added to the listing.</p>
                <p>Feel free to head on over to the <a href="/codes">codes</a> page to add goodies to your site!</p>
            </div>

            <form style={{display: (loading === true || submitted === true) ? 'none' : 'flex' }} onSubmit={saveResponse}  className="form"  id="joinform">
                <label>
                    Name:
                    <input type="text" name="name" required aria-required="true"/>
                </label>
                <label>
                    Email:
                    <input type="text" name="email" required aria-required="true"/>
                </label>
                <p id="email-selector">
                    Show email address on the list?
                    <input type="radio" name="show-email" id="show-email-true" value="Yes" defaultChecked required/>
                    <label htmlFor="show-email-true">Yes</label>
                    <input type="radio" name="show-email" id="show-email-false" value="No" required />
                    <label htmlFor="show-email-false">No</label>

                </p>
                 <label>
                   Country:
                    <CountrySelect
                        containerClassName="form-group"
                        inputClassName=""
                        onChange={(_country) => setCountry(_country)}
                        placeHolder="Select Country"
                        required
                    />
                </label>
                {/* <label>
                   Passphrase*:
                    <input type="text" name="passphrase" required/>
                </label> */}
                <label>
                   Website URL:
                <input type="text" name="site" required aria-required="true"/>
                </label>
                <label>
                   Favorite princess?:
                <input type="text" name="princess"/>
                </label>
                <input type="submit" value="Submit" />
                </form>
        </div>
    // </div>
  );
}

export default Join;